var PaletteItemName;
(function(PaletteItemName) {
    PaletteItemName["torchRed"] = "torchRed";
    PaletteItemName["electricBlue"] = "electricBlue";
    PaletteItemName["business"] = "business";
    PaletteItemName["yolk"] = "yolk";
    PaletteItemName["broccoli"] = "broccoli";
    PaletteItemName["eggplant"] = "eggplant";
    PaletteItemName["tomato"] = "tomato";
    PaletteItemName["grey"] = "grey";
})(PaletteItemName || (PaletteItemName = {}));
var TypographyItemName;
(function(TypographyItemName) {
    TypographyItemName["TinyParagraph"] = "TinyParagraph";
    TypographyItemName["TinyParagraphItalic"] = "TinyParagraphItalic";
    TypographyItemName["TinyParagraphUnderline"] = "TinyParagraphUnderline";
    TypographyItemName["TinyParagraphStrike"] = "TinyParagraphStrike";
    TypographyItemName["TinyParagraphBold"] = "TinyParagraphBold";
    TypographyItemName["SmallParagraph"] = "SmallParagraph";
    TypographyItemName["SmallParagraphItalic"] = "SmallParagraphItalic";
    TypographyItemName["SmallParagraphUnderline"] = "SmallParagraphUnderline";
    TypographyItemName["SmallParagraphStrike"] = "SmallParagraphStrike";
    TypographyItemName["SmallParagraphBold"] = "SmallParagraphBold";
    TypographyItemName["Paragraph"] = "Paragraph";
    TypographyItemName["RegularParagraph"] = "RegularParagraph";
    TypographyItemName["RegularParagraphItalic"] = "RegularParagraphItalic";
    TypographyItemName["RegularParagraphUnderline"] = "RegularParagraphUnderline";
    TypographyItemName["RegularParagraphStrike"] = "RegularParagraphStrike";
    TypographyItemName["RegularParagraphBold"] = "RegularParagraphBold";
    TypographyItemName["LargeParagraph"] = "LargeParagraph";
    TypographyItemName["LargeParagraphItalic"] = "LargeParagraphItalic";
    TypographyItemName["LargeParagraphUnderline"] = "LargeParagraphUnderline";
    TypographyItemName["LargeParagraphStrike"] = "LargeParagraphStrike";
    TypographyItemName["LargeParagraphBold"] = "LargeParagraphBold";
    TypographyItemName["SmallCapsHeadline"] = "SmallCapsHeadline";
    TypographyItemName["SmallCapsHeadlineExpanded"] = "SmallCapsHeadlineExpanded";
    TypographyItemName["SuperTinyHeadline"] = "SuperTinyHeadline";
    TypographyItemName["TinyHeadline"] = "TinyHeadline";
    TypographyItemName["SmallHeadline"] = "SmallHeadline";
    TypographyItemName["Subheadline"] = "Subheadline";
    TypographyItemName["RegularHeadline"] = "RegularHeadline";
    TypographyItemName["Headline"] = "Headline";
    TypographyItemName["MediumHeadline"] = "MediumHeadline";
    TypographyItemName["SuperHeadline"] = "SuperHeadline";
    TypographyItemName["HugeHeadline"] = "HugeHeadline";
})(TypographyItemName || (TypographyItemName = {}));
const spacers = {
    XS: "2px",
    S: "4px",
    M: "8px",
    ["2M"]: "12px",
    L: "16px",
    ["2L"]: "20px",
    XL: "24px",
    XXL: "32px",
    ["3XL"]: "40px",
    ["4XL"]: "48px",
    ["5XL"]: "56px",
    ["6XL"]: "64px",
    ["7XL"]: "96px",
    ["8XL"]: "128px",
    ["9XL"]: "200px"
};
const semanticColors = {
    brand: {
        baseBlack: "#1A1A1A",
        white: "#FFFFFF",
        lighterExciteRed: "#FFEEF3",
        lightExciteRed: "#FE88A8",
        baseExciteRed: "#FE1251",
        lightCheerYellow: "#FCF8E3",
        baseCheerYellow: "#F5E960",
        lightProsperGreen: "#EFF8A9",
        baseProsperGreen: "#3ACFB9",
        lightLoyalBlue: "#DBF8FF",
        baseLoyalBlue: "#59DEF3",
        darkElectricBlue: "#182D99",
        baseElectricBlue: "#415FFF",
        lightElectricBlue: "#EDF0FF"
    },
    status: {
        baseGreen: "#53B023",
        darkGreen: "#47961E",
        baseYellow: "#FFC700",
        darkYellow: "#EDA210",
        baseRed: "#EF432D",
        darkRed: "#B33222"
    },
    text: {
        white: "#FFFFFF",
        darkerGrey: "#333333",
        baseExciteRed: "#FE1251",
        lightGrey: "#CCCCCC",
        baseGrey: "#999999",
        darkGrey: "#666666"
    },
    stroke: {
        lighterGrey: "#F1F1F1",
        baseGrey: "#999999",
        darkerGrey: "#333333"
    },
    hover: {
        lighterGrey: "#F1F1F1",
        superDarkGrey: "#18191F",
        darkExciteRed: "#BA264D"
    },
    background: {
        lighterExciteRed: "#FFEEF3",
        baseExciteRed: "#FE1251",
        lightRed: "#FDE3E0",
        lightYellow: "#FFF7D9",
        lightGreen: "#E5F3DE",
        white: "#FFFFFF",
        superLightGrey: "#F7F7F7",
        darkerGrey: "#333333"
    }
};

export { PaletteItemName, TypographyItemName, semanticColors, spacers };
